var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFundoClaro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.627,
    height: 75,
    viewBox: "0 0 67.627 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LogoSVG",
    transform: "translate(-411.005 -124.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(411.005 124.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M497.36,167.707H442.669V124.643l54.617.271Z",
    transform: "translate(-436.18 -124.643)",
    fill: "#780000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M472.233,174.631q-.272-.375-.555-.743a34.305,34.305,0,0,0-2.95-3.364,33.813,33.813,0,0,0-47.82,0,34.313,34.313,0,0,0-2.973,3.394q-.282.368-.553.743a33.844,33.844,0,0,0,.212,39.84q.351.473.72.935a34.329,34.329,0,0,0,2.594,2.908,33.813,33.813,0,0,0,47.82,0,34.351,34.351,0,0,0,2.669-3q.367-.464.716-.939a33.842,33.842,0,0,0,.12-39.772",
    transform: "translate(-411.005 -153.247)",
    fill: "#780000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0 1.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(8.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M664.279,147.379l-9.2,4.819a31.415,31.415,0,0,1,3.652,2.029l5.574-1.787Z",
    transform: "translate(-613.415 -144.625)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M637.8,134.955l-5.967,5.495c1.023.327,2.033.693,3.02,1.1l10.187-6.558Z",
    transform: "translate(-594.935 -134.747)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M686.181,183.8l-3.6.808a21.59,21.59,0,0,1,1.838,1.631q.94.939,1.784,1.947Z",
    transform: "translate(-635.281 -173.583)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M456.346,133.94l10.361,6.565c1.034-.424,2.092-.8,3.164-1.131l-5.946-5.4Z",
    transform: "translate(-455.407 -133.94)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M451.854,151.4l5.683,1.776a31.3,31.3,0,0,1,3.78-2.136l-9.45-4.862Z",
    transform: "translate(-451.836 -143.673)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M451.766,188.19q.856-1.02,1.808-1.974a23.53,23.53,0,0,1,1.848-1.656l-3.644-.79Z",
    transform: "translate(-451.766 -173.559)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M507.336,134.194l4.565,4.957q1.3-.344,2.614-.592l-2.8-4.343Z",
    transform: "translate(-495.948 -134.142)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M537.983,134.346l2.156,4.116q1.141-.177,2.271-.28l-1.225-3.82Z",
    transform: "translate(-520.315 -134.263)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M597.352,134.663l-1.228,3.929q1.089.139,2.2.342l2.189-4.256Z",
    transform: "translate(-566.542 -134.515)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M615.566,134.785l-2.842,4.486c.834.179,1.668.385,2.5.617l4.612-5.082Z",
    transform: "translate(-579.74 -134.612)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M561.006,134.46l.837,3.73c.632-.036,1.259-.057,1.878-.057l.227,0-.178-3.662Z",
    transform: "translate(-538.62 -134.353)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M580.622,138.241q1.023.041,2.077.145l.826-3.812-2.751-.014Z",
    transform: "translate(-554.216 -134.433)",
    fill: "#D69947"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M504.347,190.261a.809.809,0,0,0,.142.216.35.35,0,0,0,.169.1,1.543,1.543,0,0,0,.286.03l.586.035a1.145,1.145,0,0,1,.176.027c.038.01.074.05.107.117l.3.618q.1.212-.089.306l-.086.042a.212.212,0,0,1-.321-.107l-.1-.2-.486.236.089.182q.324.668.906.386l.3-.145a.59.59,0,0,0,.29-.9l-.376-.775a.713.713,0,0,0-.162-.243.38.38,0,0,0-.155-.069,2.3,2.3,0,0,0-.28-.03l-.581-.024a1.183,1.183,0,0,1-.176-.027c-.039-.01-.074-.05-.107-.117l-.292-.6a.21.21,0,0,1,.1-.319l.076-.037a.211.211,0,0,1,.318.115l.155.319.486-.236-.172-.354a.593.593,0,0,0-.884-.341l-.3.147a.593.593,0,0,0-.28.905Z",
    transform: "translate(-484.85 -177.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M520.044,186.3l.508-.182-.5-1.393.583-.208.5,1.393.508-.182-1.128-3.153a.593.593,0,0,0-.842-.434l-.381.136a.592.592,0,0,0-.376.869Zm-.465-3.6.138-.049a.209.209,0,0,1,.3.143l.453,1.266-.583.208-.453-1.266a.209.209,0,0,1,.143-.3",
    transform: "translate(-496.752 -172.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M535.88,181.072l-.61-2.574.989,1.657.185.783.525-.125-.931-3.931-.526.124.45,1.9-1.014-1.767-.525.125.932,3.931Z",
    transform: "translate(-509.132 -168.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M550.754,175.073l.461,3.521.536-.07L551.29,175l.513-.067-.064-.485-1.562.2.064.485Z",
    transform: "translate(-521.658 -166.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M566.35,177.722l-.042-1.48.619-.017.042,1.479.54-.015-.095-3.347q-.02-.692-.666-.673l-.4.011q-.647.018-.627.71l.095,3.347Zm.136-3.556.146,0a.209.209,0,0,1,.243.23l.038,1.344-.619.018-.038-1.344a.209.209,0,0,1,.229-.243",
    transform: "translate(-534.011 -165.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M590.983,177.194l.323.048.112,1.666.506.075-.128-1.719q.338-.093.415-.616l.146-.985q.1-.684-.511-.775l-1.047-.155-.589,4,.534.079Zm.28-1.9.351.052q.239.035.2.325l-.127.863q-.042.289-.282.254l-.351-.052Z",
    transform: "translate(-553.487 -166.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M605.843,182.243l.49.129a.592.592,0,0,0,.806-.5l.677-2.574a.593.593,0,0,0-.45-.834l-.5-.132a.592.592,0,0,0-.8.5l-.677,2.574a.592.592,0,0,0,.457.83m.076-.731.658-2.5a.209.209,0,0,1,.289-.168l.245.064a.211.211,0,0,1,.174.29l-.658,2.5c-.04.152-.129.211-.267.174l-.266-.07a.211.211,0,0,1-.174-.29",
    transform: "translate(-565.523 -169.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M620.725,187.243l.31.119a.589.589,0,0,0,.853-.4l.308-.8a.713.713,0,0,0,.067-.285.381.381,0,0,0-.056-.16,2.325,2.325,0,0,0-.17-.225l-.379-.441a1.124,1.124,0,0,1-.1-.147.2.2,0,0,1,.012-.158l.24-.625a.209.209,0,0,1,.3-.143l.079.03a.212.212,0,0,1,.134.31l-.127.331.5.193.141-.368a.592.592,0,0,0-.356-.878l-.315-.121a.593.593,0,0,0-.852.414l-.3.773a.807.807,0,0,0-.06.251.347.347,0,0,0,.045.189,1.578,1.578,0,0,0,.174.23l.375.451a1.143,1.143,0,0,1,.1.147.2.2,0,0,1-.013.158l-.246.641q-.084.221-.284.144l-.089-.034a.211.211,0,0,1-.141-.307l.078-.2-.5-.193-.072.189q-.266.693.338.925",
    transform: "translate(-577.415 -173.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M633.246,193.54l.675-1.317.551.282-.675,1.317.481.246,1.526-2.98a.593.593,0,0,0-.26-.911l-.361-.185a.593.593,0,0,0-.891.321l-1.526,2.98Zm1.511-2.95a.209.209,0,0,1,.318-.1l.13.067a.209.209,0,0,1,.1.318l-.613,1.2-.551-.282Z",
    transform: "translate(-587.321 -178.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M533.528,454.591l.51.177.6-1.733.67.233.161-.462-.669-.233.4-1.159.755.262.161-.463-1.265-.44Z",
    transform: "translate(-508.42 -385.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M549.49,457.977c-.036.173-.126.244-.269.214l-.215-.045q-.231-.049-.177-.308l.677-3.216-.529-.111-.674,3.2q-.159.754.474.888l.446.094q.638.135.8-.614l.675-3.2-.529-.112Z",
    transform: "translate(-520.143 -388.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M565.319,457.512l.516.039-.27,3.541.539.041.27-3.54.516.039.037-.488-1.571-.12Z",
    transform: "translate(-533.696 -390.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M580.2,459.591a.391.391,0,0,0-.116-.123,2.432,2.432,0,0,0-.247-.136l-.526-.248a1.1,1.1,0,0,1-.152-.093.2.2,0,0,1-.053-.149l-.035-.669q-.013-.242.218-.254l.084,0a.211.211,0,0,1,.249.229l.019.354.539-.028-.021-.393q-.037-.691-.683-.657l-.337.018q-.646.034-.609.725l.044.826a.8.8,0,0,0,.047.254.349.349,0,0,0,.118.155,1.635,1.635,0,0,0,.253.139l.526.259a1.148,1.148,0,0,1,.152.093.2.2,0,0,1,.053.149l.036.686q.013.236-.2.247l-.1,0a.211.211,0,0,1-.254-.223l-.012-.219-.539.029.011.2q.039.742.685.707l.332-.017a.59.59,0,0,0,.616-.715l-.046-.86a.722.722,0,0,0-.055-.287",
    transform: "translate(-544.199 -391.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M593.677,455.493l-.4.077a.593.593,0,0,0-.5.8l.634,3.288.53-.1-.28-1.453.608-.117.28,1.453.531-.1-.634-3.288q-.131-.679-.766-.557m-.111,2.13-.254-1.321a.209.209,0,0,1,.187-.277l.144-.028a.209.209,0,0,1,.277.187l.255,1.321Z",
    transform: "translate(-555.508 -389.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M608.094,455.866l-1.089-3.38-.514.165,1.239,3.846,1.221-.393-.15-.466Z",
    transform: "translate(-566.431 -387.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M472.233,174.631q-.272-.375-.555-.743a34.305,34.305,0,0,0-2.95-3.364,33.813,33.813,0,0,0-47.82,0,34.313,34.313,0,0,0-2.973,3.394q-.282.368-.553.743a33.844,33.844,0,0,0,.212,39.84q.351.473.72.935a34.329,34.329,0,0,0,2.594,2.908,33.813,33.813,0,0,0,47.82,0,34.351,34.351,0,0,0,2.669-3q.367-.464.716-.939a33.842,33.842,0,0,0,.12-39.772m-.641,39.516a33.229,33.229,0,0,1-53.477.1q-.346-.465-.674-.942a33.189,33.189,0,0,1-.061-37.647q.271-.395.553-.781a33.228,33.228,0,0,1,53.75-.029q.283.387.555.782a33.19,33.19,0,0,1,.026,37.578q-.328.478-.671.943",
    transform: "translate(-411.005 -155.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M665.8,243.941a24.423,24.423,0,0,1,.53,31.609l.139.649a24.945,24.945,0,0,0-.669-33.041Z",
    transform: "translate(-613.587 -220.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M510.149,207.746a24.43,24.43,0,0,1,25.378-.04h.979a24.941,24.941,0,0,0-27.333.04Z",
    transform: "translate(-489.057 -189.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M459.186,281.907v-.875a24.419,24.419,0,0,1,0-28.612v-.875a24.939,24.939,0,0,0,0,30.363",
    transform: "translate(-445.216 -227.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M535.583,427.686a24.432,24.432,0,0,1-25.358-.027l-.981,0a24.942,24.942,0,0,0,27.318.03h-.979Z",
    transform: "translate(-489.113 -367.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M498.93,268.382a3.868,3.868,0,0,0,.9-.536,3.315,3.315,0,0,0,.7-.735,1.4,1.4,0,0,0,.271-.795V250.069a1.652,1.652,0,0,0-.519-1.112,8.532,8.532,0,0,0-.924-.874l-8.614-5.561a2.39,2.39,0,0,1-.226-.238.46.46,0,0,1-.135-.278v-7.23l.361-.278h4.194v6.355l5.863-3.1v-6.4a1.544,1.544,0,0,0-.271-.794,3.976,3.976,0,0,0-.676-.815,3.8,3.8,0,0,0-.879-.616,2.053,2.053,0,0,0-.925-.238H487.588a2.669,2.669,0,0,0-1.082.238,4.608,4.608,0,0,0-1.015.616,3.315,3.315,0,0,0-.766.854,1.8,1.8,0,0,0-.293.954v13.109a1.958,1.958,0,0,0,.316.874,2.43,2.43,0,0,0,.586.755l9.561,6.157v10.566h-4.329l-.271-.357v-5.681q-5.8-3.337-5.862-3.337h0v12.315a1.588,1.588,0,0,0,.226.794,3.168,3.168,0,0,0,.609.755,5.8,5.8,0,0,0,.812.636,3.191,3.191,0,0,0,.834.4l1.083,0,.879,0,9.177.033a2.284,2.284,0,0,0,.88-.2",
    transform: "translate(-469.384 -209.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M593.208,265.074l-3.791-17.663v-.4q.5-.437,1.037-.933a9.8,9.8,0,0,0,.992-1.053,5.887,5.887,0,0,0,.744-1.172,2.97,2.97,0,0,0,.293-1.291V231.4c0-.038,0-.077-.007-.115a2.4,2.4,0,0,0-.219-.858c-.024-.053-.051-.1-.077-.153a3.114,3.114,0,0,0-.509-.721,3.04,3.04,0,0,0-.834-.616,2.353,2.353,0,0,0-.426-.165,1.844,1.844,0,0,0-.5-.073H574.941v39.724h6.088V252.417l2.932-1.867,3.878,17.876h6.088l-.585-2.728Zm-7.083-22.708a3.55,3.55,0,0,1-.361.358,5.238,5.238,0,0,1-.451.358l-4.239,2.582V234.381h5.051Z",
    transform: "translate(-541.347 -209.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(411.097 124.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(8.33 1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M664.039,147.814l-9.176,4.806a31.307,31.307,0,0,1,3.642,2.024l5.559-1.782Z",
    transform: "translate(-613.313 -145.068)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M637.634,135.424l-5.951,5.48c1.021.326,2.028.692,3.012,1.1l10.159-6.541Z",
    transform: "translate(-594.883 -135.217)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M685.882,184.137l-3.592.806a21.511,21.511,0,0,1,1.833,1.627q.937.937,1.78,1.941Z",
    transform: "translate(-635.119 -173.947)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M456.671,134.412,467,140.959c1.032-.423,2.086-.8,3.155-1.128l-5.93-5.382Z",
    transform: "translate(-455.735 -134.412)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M452.191,151.826l5.668,1.772a31.2,31.2,0,0,1,3.77-2.13L452.2,146.62Z",
    transform: "translate(-452.173 -144.118)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M452.1,188.515q.854-1.017,1.8-1.969a23.481,23.481,0,0,1,1.843-1.651l-3.635-.788Z",
    transform: "translate(-452.103 -173.923)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M507.523,134.665l4.552,4.943q1.3-.342,2.607-.591l-2.788-4.331Z",
    transform: "translate(-496.166 -134.613)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M538.086,134.817l2.15,4.1q1.138-.176,2.265-.279l-1.221-3.81Z",
    transform: "translate(-520.466 -134.734)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M597.294,135.133l-1.225,3.918q1.087.139,2.189.341l2.183-4.244Z",
    transform: "translate(-566.567 -134.985)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M615.459,135.255l-2.835,4.474c.831.179,1.664.384,2.491.616l4.6-5.069Z",
    transform: "translate(-579.73 -135.082)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M561.047,134.931l.834,3.72c.63-.036,1.256-.057,1.873-.057l.226,0-.177-3.652Z",
    transform: "translate(-538.722 -134.825)",
    fill: "#D69947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M580.609,138.7q1.02.041,2.071.144l.824-3.8-2.744-.014Z",
    transform: "translate(-554.275 -134.903)",
    fill: "#D69947"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M504.542,190.58a.808.808,0,0,0,.142.215.35.35,0,0,0,.169.1,1.554,1.554,0,0,0,.285.03l.584.035a1.171,1.171,0,0,1,.176.027c.038.01.074.05.106.117l.3.616q.1.212-.089.305l-.086.041a.211.211,0,0,1-.32-.107l-.1-.2-.485.235.088.182q.323.666.9.385l.3-.144a.588.588,0,0,0,.29-.895l-.375-.773a.711.711,0,0,0-.161-.242.376.376,0,0,0-.155-.068,2.287,2.287,0,0,0-.279-.03l-.58-.024a1.178,1.178,0,0,1-.175-.027c-.039-.01-.074-.05-.107-.117l-.291-.6a.209.209,0,0,1,.1-.318l.076-.036a.211.211,0,0,1,.317.114l.155.318.485-.235-.172-.353a.591.591,0,0,0-.882-.34l-.3.147a.591.591,0,0,0-.28.9Z",
    transform: "translate(-485.098 -175.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M520.2,186.628l.507-.181-.5-1.39.581-.208.5,1.39.507-.182-1.124-3.144a.591.591,0,0,0-.84-.433l-.38.136a.591.591,0,0,0-.375.867Zm-.463-3.6.137-.049a.208.208,0,0,1,.3.143l.452,1.263-.581.208-.452-1.263a.208.208,0,0,1,.143-.3",
    transform: "translate(-496.967 -170.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M535.989,181.416l-.608-2.567.986,1.652.185.781.524-.124-.929-3.921-.524.124.449,1.9L535.06,177.5l-.524.124.929,3.921Z",
    transform: "translate(-509.313 -166.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M550.823,175.433l.46,3.511.534-.07-.459-3.511.512-.067-.063-.484-1.558.2.063.484Z",
    transform: "translate(-521.806 -164.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M566.376,178.074l-.042-1.475.617-.017.042,1.475.539-.015-.094-3.338q-.02-.69-.665-.672l-.4.011q-.646.018-.626.708l.094,3.338Zm.135-3.546.146,0a.208.208,0,0,1,.242.229l.038,1.34-.617.018-.038-1.341a.208.208,0,0,1,.229-.242",
    transform: "translate(-534.125 -164.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M590.942,177.548l.322.048.112,1.662.5.075-.127-1.715q.337-.093.414-.614l.145-.983q.1-.682-.51-.773l-1.044-.154-.588,3.986.533.079Zm.279-1.893.35.051q.238.035.2.324l-.127.86c-.028.192-.122.277-.281.253l-.35-.052Z",
    transform: "translate(-553.548 -164.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M605.762,182.584l.489.129a.591.591,0,0,0,.8-.5l.675-2.567a.591.591,0,0,0-.449-.832l-.5-.131a.591.591,0,0,0-.8.5l-.675,2.567a.591.591,0,0,0,.456.827m.076-.729.656-2.5a.208.208,0,0,1,.288-.168l.244.064a.211.211,0,0,1,.174.289l-.656,2.5c-.04.152-.129.21-.266.174l-.266-.07a.211.211,0,0,1-.174-.289",
    transform: "translate(-565.552 -167.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M620.6,187.57l.309.118a.588.588,0,0,0,.851-.4l.307-.8a.712.712,0,0,0,.067-.284.383.383,0,0,0-.056-.16,2.317,2.317,0,0,0-.169-.224l-.378-.44a1.119,1.119,0,0,1-.1-.147.2.2,0,0,1,.012-.158l.239-.624a.208.208,0,0,1,.3-.143l.078.03a.211.211,0,0,1,.134.31l-.127.33.5.193.141-.367a.591.591,0,0,0-.355-.875l-.315-.121a.591.591,0,0,0-.85.413l-.3.771a.8.8,0,0,0-.06.25.347.347,0,0,0,.045.189,1.589,1.589,0,0,0,.174.229l.374.45a1.136,1.136,0,0,1,.1.147.2.2,0,0,1-.012.158l-.245.639q-.084.22-.283.144l-.089-.034a.211.211,0,0,1-.141-.307l.078-.2-.5-.193-.072.189q-.266.691.337.923",
    transform: "translate(-577.411 -171.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M633.09,193.849l.673-1.314.549.281-.673,1.314.48.245,1.522-2.972a.591.591,0,0,0-.259-.909l-.36-.184a.591.591,0,0,0-.889.32l-1.522,2.972Zm1.507-2.942a.208.208,0,0,1,.317-.1l.13.067a.208.208,0,0,1,.1.317l-.611,1.194-.549-.281Z",
    transform: "translate(-587.291 -176.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M533.643,454.192l.509.177.6-1.728.668.232.16-.461-.668-.232.4-1.155.753.262.16-.461-1.262-.438Z",
    transform: "translate(-508.604 -383.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M549.563,457.569c-.036.172-.126.243-.269.213l-.214-.046q-.231-.048-.176-.307l.676-3.207-.527-.111-.672,3.191q-.158.752.473.885l.445.094q.637.134.794-.613l.673-3.2-.527-.111Z",
    transform: "translate(-520.295 -386.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M565.348,457.1l.515.039-.269,3.531.537.041.269-3.53.515.039.037-.487-1.567-.119Z",
    transform: "translate(-533.811 -388.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M580.189,459.178a.388.388,0,0,0-.116-.123,2.4,2.4,0,0,0-.246-.136l-.524-.248a1.1,1.1,0,0,1-.151-.093.2.2,0,0,1-.053-.149l-.035-.667q-.013-.241.217-.253l.084,0a.211.211,0,0,1,.248.229l.019.353.538-.028-.021-.392q-.037-.689-.681-.655l-.336.018q-.644.034-.608.723l.044.824a.786.786,0,0,0,.047.253.349.349,0,0,0,.118.154,1.646,1.646,0,0,0,.252.138l.525.259a1.151,1.151,0,0,1,.151.093.2.2,0,0,1,.053.149l.036.684q.013.235-.2.247l-.1,0a.211.211,0,0,1-.253-.223l-.012-.218-.538.028.011.2q.039.74.684.705l.331-.017a.588.588,0,0,0,.614-.712l-.046-.858a.719.719,0,0,0-.054-.286",
    transform: "translate(-544.285 -389.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M593.629,455.092l-.4.077q-.634.122-.5.8l.632,3.279.529-.1-.279-1.449.606-.117.279,1.449.529-.1-.632-3.279q-.131-.677-.764-.555m-.11,2.124-.254-1.317a.209.209,0,0,1,.187-.276l.143-.027a.208.208,0,0,1,.276.187l.254,1.317Z",
    transform: "translate(-555.564 -387.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M608.007,455.463l-1.086-3.37-.513.165,1.235,3.835,1.218-.392-.15-.465Z",
    transform: "translate(-566.457 -385.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M665.557,244.114a24.357,24.357,0,0,1,.529,31.523l.139.647a24.877,24.877,0,0,0-.667-32.951Z",
    transform: "translate(-613.485 -219.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M510.328,208.018a24.364,24.364,0,0,1,25.309-.039h.977a24.874,24.874,0,0,0-27.258.039Z",
    transform: "translate(-489.293 -187.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M459.5,281.976V281.1a24.353,24.353,0,0,1,0-28.534V251.7a24.872,24.872,0,0,0,0,30.28",
    transform: "translate(-445.571 -225.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M535.692,427.36a24.365,24.365,0,0,1-25.289-.027l-.979,0a24.874,24.874,0,0,0,27.244.03h-.977Z",
    transform: "translate(-489.348 -365.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    "data-name": "Caminho 202",
    d: "M499.14,268.488a3.862,3.862,0,0,0,.9-.535,3.3,3.3,0,0,0,.7-.733,1.4,1.4,0,0,0,.27-.793v-16.2a1.649,1.649,0,0,0-.517-1.109,8.526,8.526,0,0,0-.922-.872l-8.591-5.546a2.4,2.4,0,0,1-.225-.238.458.458,0,0,1-.135-.277v-7.21l.36-.277h4.183v6.338l5.847-3.09v-6.378a1.539,1.539,0,0,0-.27-.792,3.96,3.96,0,0,0-.675-.812,3.787,3.787,0,0,0-.877-.614,2.048,2.048,0,0,0-.922-.238H487.828a2.663,2.663,0,0,0-1.079.238,4.594,4.594,0,0,0-1.012.614,3.3,3.3,0,0,0-.764.852,1.8,1.8,0,0,0-.292.951v13.073a1.953,1.953,0,0,0,.315.872,2.422,2.422,0,0,0,.584.753l9.535,6.141v10.538H490.8l-.27-.356v-5.665q-5.781-3.328-5.846-3.328h0v12.281a1.584,1.584,0,0,0,.225.792,3.16,3.16,0,0,0,.607.753,5.783,5.783,0,0,0,.81.634,3.182,3.182,0,0,0,.832.4l1.08,0,.876,0,9.152.032a2.279,2.279,0,0,0,.877-.2",
    transform: "translate(-469.674 -207.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    "data-name": "Caminho 203",
    d: "M593.161,265.19l-3.78-17.615v-.4q.494-.435,1.034-.931a9.755,9.755,0,0,0,.99-1.05,5.871,5.871,0,0,0,.742-1.169,2.96,2.96,0,0,0,.292-1.288V231.61c0-.038,0-.076-.007-.115a2.383,2.383,0,0,0-.218-.856c-.024-.052-.051-.1-.077-.152a3.1,3.1,0,0,0-.508-.719,3.03,3.03,0,0,0-.832-.614,2.339,2.339,0,0,0-.424-.165,1.835,1.835,0,0,0-.5-.073H574.944v39.616h6.071V252.567l2.924-1.862,3.868,17.827h6.071l-.584-2.72ZM586.1,242.544a3.559,3.559,0,0,1-.36.357,5.184,5.184,0,0,1-.45.357l-4.228,2.575V234.581H586.1Z",
    transform: "translate(-541.441 -207.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    "data-name": "Caminho 204",
    d: "M443.424,125.7l53.364.264.072,18.651.554,0-.074-19.2-54.468-.27-.041,18.946h.554Z",
    transform: "translate(-436.4 -125.14)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFundoClaro);
export default __webpack_public_path__ + "static/media/logo_fundo_claro.6cb9355055caae235b41b81c235a3602.svg";
export { ForwardRef as ReactComponent };